export class Mask {

    static initEl(el){
        const inputType = el.dataset.mask;

        switch (inputType) {
            case "date":
                new Cleave(el, {
                    date: true,
                    datePattern: ['d', 'm', 'Y'],
                    delimiter: '/'
                });
                break;

            case "time":
                new Cleave(el, {
                    time: true,
                    timePattern: ['h', 'm']
                });
                break;
            case "integer":
                new Cleave(el, {
                    numeral: true,
                    numeralThousandsGroupStyle: "none",
                    numeralDecimalScale: 0,
                    numeralDecimalMark: ""
                });
                break;

            case "decimal":
                new Cleave(el, {
                    numeral: true,
                    numeralThousandsGroupStyle: "none"
                });
                break;

            case "duration":
                const pattern = el.dataset.pattern;
                new Cleave(el, {
                    time: true,
                    timePattern: pattern.split(",")
                });
                break;
            case "currency":
                new Cleave(el, {
                    numeral: true,
                    numeralThousandsGroupStyle: "none",
                    numeralPositiveOnly: true
                });
                break;
        }
    }
    static init() {
        Array.from(document.querySelectorAll('[data-mask]')).forEach(function (el) {
            Mask.initEl(el);
        });
    }
}
